import React from 'react';
import { BsPlusLg } from 'react-icons/bs';
import { FaTrash } from 'react-icons/fa';

const SigorRelacionadas = (props) => {

  function add_acondicionamento(id) {
    if (!props.state.acondicionamentos_selecionados.filter(item => item.id === id)[0]) {
      const acondicionamento = props.state.acondicionamentos.filter(item => item.id === id)[0]
      const acondicionamentos = props.state.acondicionamentos.filter(item => item.id !== id)

      const obj_acondicionamento = {
        id: acondicionamento.id,
        descricao: acondicionamento.descricao,
        codigo: acondicionamento.codigo
      }

      props.setState({ ...props.state, acondicionamentos_selecionados: [...props.state.acondicionamentos_selecionados, obj_acondicionamento], acondicionamentos, acondicionamento_id: acondicionamentos[0].id })
    }
  }

  function remove_acondicionamento(id) {
    const acondicionamentos_selecionados = props.state.acondicionamentos_selecionados.filter(item => item.id !== id)
    const devolution = props.state.all_acondicionamentos.filter(item => item.id === id)[0]
    let acondicionamentos = [devolution, ...props.state.acondicionamentos]

    props.setState({ ...props.state, acondicionamentos_selecionados, acondicionamentos, acondicionamento_id: acondicionamentos[0].id })
  }

  return (
    <div>
      {!props.state.loading ? <div className="form-group row">
        <label className="col-sm-12 col-form-label">Acondicionamentos Relacionais</label>
        <div className="input-group col-sm-12">
          <select value={props.state.acondicionamento_id} className="form-control" id="cameras" onChange={(e) => props.setState({ ...props.state, acondicionamento_id: e.target.value })}>
            {props.state.acondicionamentos.map(item => (
              <>{!item.relation && <option value={item.id}>{item.descricao}</option>}</>
            ))}
          </select>
          <button className='btn btn-primary' onClick={() => add_acondicionamento(props.state.acondicionamento_id)}>
            <BsPlusLg />
          </button>
        </div>
      </div>
        :
        <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
          <div className="spinner-border text-primary" role="status"></div>
        </div>}

      {props.state.acondicionamentos_selecionados.length > 0 &&
        <div className="row my-3">
          <div className="col-12">
            <table className='table table-striped table-hover text-center'>
              <thead>
                <th>Nome</th>
                <th>Código</th>
                <th>Ações</th>
              </thead>
              <tbody>
                {props.state.acondicionamentos_selecionados.map(item2 => (
                  <tr key={item2.id}>
                    <td>{item2.descricao}</td>
                    <td>{item2.codigo}</td>
                    <td><button className="btn btn-danger btn-small btn-circle m-r-5"
                      onClick={() => remove_acondicionamento(item2.id)}>
                      <FaTrash color='white' />
                    </button>
                    </td>
                  </tr>
                ))}

              </tbody>
            </table>
          </div>
        </div>}
    </div>
  )
}

export default SigorRelacionadas